import React from 'react'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import ArticleStatus from '@SonarCX/components/atoms/ArticleStatus'
import ArticleType from '@SonarCX/components/atoms/ArticleType'
import ArticleAvatar from '@SonarCX/components/atoms/ArticleAvatar'
import ArticleOptionsMenu from '@SonarCX/components/molecules/ArticleOptionsMenu'
import FavoriteButton from '@SonarCX/components/atoms/FavoriteButton'

import { formatDateRelative } from '@SonarCX/utilities'
import { selectArticle } from '@SonarCX/slices/article'
import useFavorites from '@SonarCX/hooks/useFavorites'
import useStyles from './styles'

const ArticleRow = ({
  id,
  status,
  updated_at,
  created_by,
  last_updated_by,
  published_at,
  archived_at,
  ...props
}) => {
  const dispatch = useAppDispatch()
  const { favoriteArticles } = useFavorites()

  const classes = useStyles()

  const isFavorite = React.useMemo(
    () => favoriteArticles.some(x => x.item_id === id),
    [favoriteArticles, id]
  )

  const handleRowClick = React.useCallback(() => {
    dispatch(selectArticle(id))
  }, [dispatch, id])

  // Each element below has an onClick instead of the root tr so that clicking in modals will not cause the row to be clicked

  return (
    <tr>
      <ArticleType onClick={handleRowClick} {...props} />

      <ArticleStatus
        onClick={handleRowClick}
        publishedAt={published_at}
        archivedAt={archived_at}
      />

      <ArticleAvatar onClick={handleRowClick} userId={created_by} />

      {/* <ArticlePerformance onClick={handleRowClick} {...props} /> */}

      <td onClick={handleRowClick} role='cell'>
        <label className={classes.label}>
          {updated_at ? formatDateRelative(updated_at, true) : 'Never'}
        </label>
      </td>

      <ArticleAvatar onClick={handleRowClick} userId={last_updated_by} />

      <td role='cell'>
        {props.type === 'article' && (
          <FavoriteButton itemId={id} type='article' isFavorite={isFavorite} />
        )}
      </td>

      {/* add to own small component, its placeholder for now */}
      <td role='cell'>
        <ArticleOptionsMenu articleId={id} />
      </td>
    </tr>
  )
}

export default ArticleRow
